import React, { useEffect } from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Tools() {
  const navigate = useNavigate();

  // Hardcoded module data
  const selectedModule = {
    name: "Tools",
    functions: [
      { name: "Imex", uriPath: "/imex" },
      { name: "Process", uriPath: "/process" },
      { name: "Reports", uriPath: "/reports" },
      { name: "Ftp", uriPath: "/ftp" },
      { name: "EditableGrid", uriPath: "/EditableGrid" }
    ]
  };

  // Optional: redirect if no module selected (not really needed here since it's hardcoded)
  useEffect(() => {
    if (!selectedModule) {
      navigate("/Dashboard1"); // redirect if module not found
    }
  }, [selectedModule, navigate]);

  return (
    <div style={{ padding: "2rem" }}>
      <Typography variant="h4" gutterBottom>
        Welcome to {selectedModule.name} Page
      </Typography>

      <Box
        sx={{
          backgroundColor: "#f1f1f1",
          padding: "24px",
          borderRadius: "12px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          marginTop: "20px",
        }}
      >
        <Grid container spacing={2}>
          {selectedModule.functions.map((func, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  padding: "16px",
                  borderRadius: "10px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  textAlign: "center",
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => navigate(func.uriPath)}
                  sx={{ mt: 2 }}
                >
                  {func.name}
                </Button>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
}
